import React, { useRef, useEffect } from "react";

const useOutsideAlerter = (
  ref: React.MutableRefObject<any>,
  callback: ClickOutsideProps["onClickOutside"]
) => {
  const handleClickOutside = (e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
};

interface ClickOutsideProps {
  className?: string;
  onClickOutside: (e: MouseEvent) => void;
}

const ClickOutside: React.FC<ClickOutsideProps> = ({ className, children, onClickOutside }) => {
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, onClickOutside);

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};

export default ClickOutside;
